import styled from 'styled-components';
import { Divider, Typography } from '@material-ui/core';

export const StyledDivider = styled(Divider)`
  margin-bottom: 16px;
`;

export const StyledTypography = styled(Typography)`
  font-weight: 500;
  margin-top: 16px;
  margin-bottom: 16px;
`;
